import script from "./BaseCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=1ebafa28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebafa28"]])

export default __exports__